import { useMemo, useRef, useState } from "react";
import Icon from "../Icon";
import OrigenIcono from "./OrigenIcono";
import { filtrarPool, candidatasFuera } from "./pool";

// El selector único de tarea de «Empezar una tarea»: una lista, dos zonas. Arriba lo que hay en
// Mis tareas; al pie, en la misma lista, «Buscar en todas (Notion y proyectos)». Lo de fuera lleva
// la marca «Se traerá a Mis tareas»: al empezar se da de alta. Escribir busca en las dos zonas.
//
// value: la seleccion actual ({ kind, id, title, sub, fuera }) o null. onChange(seleccion | null).
// `traer` (por defecto si): lo de fuera se da de alta en Mis tareas al empezarlo. En el Cuaderno no se trae
// nada —solo se enlaza la entrada—, asi que ahi no se promete.
// `flotante` (el Cuaderno): la lista no empuja el formulario hacia abajo. Sale como un desplegable bajo el buscador,
// tapando lo de debajo mientras se elige, y se cierra al salir del selector o con Escape.
export default function SelectorTareaUnico({ pool = [], misPasos = [], notionItems = [], value = null, onChange, traer = true, flotante = false }) {
  const [q, setQ] = useState("");
  const [todas, setTodas] = useState(false);
  const [abierto, setAbierto] = useState(false);
  const caja = useRef(null);
  const lista = !flotante || abierto;

  const dentro = useMemo(() => filtrarPool(pool, q).slice(0, 30), [pool, q]);
  const buscando = q.trim().length > 0;
  const fuera = useMemo(
    () => (buscando || todas ? candidatasFuera({ pool, misPasos, notionItems, q }) : []),
    [buscando, todas, pool, misPasos, notionItems, q]);

  if (value) {
    return (
      <div className="mt-sel-elegida">
        <OrigenIcono origen={value.kind} />
        <span className="mt-sel-t"><b>{value.title}</b><small>{value.sub}</small></span>
        {value.fuera && traer && <span className="mt-sel-tag">Se traerá a Mis tareas</span>}
        <button type="button" className="mt-sel-x btn" onClick={() => onChange(null)}
          aria-label={`Quitar el enlace: ${value.title}`}>×</button>
      </div>
    );
  }

  const fila = s => (
    <li key={`${s.kind}:${s.id}`}>
      <button type="button" className="mt-sel-op btn" onClick={() => onChange(s)}>
        <OrigenIcono origen={s.kind} />
        <span className="mt-sel-t"><b>{s.title}</b><small>{s.sub}{s.cuando ? ` · ${s.cuando}` : ""}</small></span>
        {s.fuera && traer && <span className="mt-sel-tag">Se traerá a Mis tareas</span>}
      </button>
    </li>
  );

  return (
    <div className={"mt-sel" + (flotante ? " mt-sel-f" : "")} ref={caja}
      onBlur={flotante ? e => { if (!caja.current?.contains(e.relatedTarget)) setAbierto(false); } : undefined}>
      <div className="mt-sel-busca">
        <Icon name="search" size={12} color="var(--text3)" />
        <input aria-label="Buscar tarea" value={q}
          onChange={e => { setQ(e.target.value); if (flotante) setAbierto(true); }}
          onFocus={flotante ? () => setAbierto(true) : undefined}
          onClick={flotante ? () => setAbierto(true) : undefined}
          onKeyDown={e => {
            if (e.key === "Enter") { e.preventDefault(); const p = dentro[0] || fuera[0]; if (p) onChange(p); }
            else if (e.key === "Escape" && flotante && abierto) { e.preventDefault(); e.stopPropagation(); setAbierto(false); }
          }}
          placeholder="Buscar en Mis tareas…" />
      </div>

      {lista && <div className={flotante ? "mt-sel-flota" : undefined}>
      <div className="mt-sel-gl">Mis tareas{!buscando && <span> · lo planificado primero</span>}</div>
      {dentro.length ? <ul className="mt-sel-lista" aria-label="Mis tareas">{dentro.map(fila)}</ul>
        : <p className="mt-sel-nota">{pool.length
            ? "Nada coincide en Mis tareas."
            : traer ? "Aún no tienes tareas en Mis tareas. Busca la que vas a hacer y se añadirá sola."
                    : "Aún no tienes tareas en Mis tareas. Busca la tarea en todas."}</p>}

      {(buscando || todas) && (
        <>
          <div className="mt-sel-gl">{traer ? "No están en Mis tareas" : "Fuera de Mis tareas"} <span> · Notion y proyectos</span></div>
          {fuera.length ? <ul className="mt-sel-lista" aria-label={traer ? "No están en Mis tareas" : "Fuera de Mis tareas"}>{fuera.map(fila)}</ul>
            : <p className="mt-sel-nota">Sin resultados.</p>}
        </>
      )}
      {!todas && !buscando && (
        <div className="mt-sel-pie">
          <button type="button" className="mt-sel-todas btn" onClick={() => setTodas(true)}>
            <Icon name="search" size={12} color="currentColor" />Buscar en todas (Notion y proyectos)
          </button>
        </div>
      )}
      </div>}
    </div>
  );
}
